import React, { useEffect } from 'react'
import GetW8W9FormsModal from './getw8w9formsmodal/GetW8W9FormsModal'
import { W8W9_REQUESTS_PLANS } from '../../../recipientssection/recipientlist/constants'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setSelectedW8W9Form, setSelectedW8W9Plan, setW8W9FormsModal, setW8W9PaymentDrawerModal, setW9RequestModal } from './W8W9PaymentModalSlice'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import PaymentDrawer from '../../paymentdrawer/PaymentDrawer'
import RecipientDataService from '../../../../../services/RecipientDataService'
import General from '../../../../../libs/utility/General'
import { getW8Forms, requestBulkW8, requestBulkW9 } from './W8W9PaymentModalSaga'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../paymentdrawer/constants'
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { REQUEST_TYPE_STATUS } from '../steps/getrequesttype/constants'
import { RECIPIENT_SECTION_ROUTES } from '../../../recipientssection/constants'
import { TOASTER_VARIANT } from '../../../../components/toast/constants'
import { W8_W9_PAYMENT_MODAL_LOADING_STATES } from './constants'
import Loadable from '../../../../components/loadable/Loadable'
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook'

const W8W9PaymentModals = ({ submittedRecipient = {}, requestType, recipientIds = [], payerId = null, W8W9Fees = 0 }) => {

    const dispatch = useDispatch();
    const navigate = useTxNavigate();

    const { selectedW8W9Plan, selectedW8W9Form, w8W9PlanModal, w8W9PaymentDrawerModal, w8W9FormsModal, w8Forms, w9RequestModal, loadingState } = useSelector(state => state[componentKey])

    useEffect(() => {
        dispatch(getW8Forms());
        dispatch(setW8W9PaymentDrawerModal(false));
    }, []);

    const { DISPLAY_PLANS_VIEW_LOADING, GET_W8_FORMS_LOADING } = W8_W9_PAYMENT_MODAL_LOADING_STATES;

    return (
        <>
            <GetW8W9FormsModal
                title="Select Form"
                isOpen={w8W9FormsModal}
                bodyText="Please select a W8 Form and click on Send Request"
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        if (selectedW8W9Form?.value?.length !== 0) {
                            const data = {
                                RecipientIds: Array.isArray(recipientIds) ? recipientIds : [recipientIds],
                                totalAmount: W8W9Fees,
                                prepay: "Yes",
                                isPrepaid: "true",
                                selectAll: "false",
                                isAccountant: "true",
                                placeOfOriginforpayment: PLACE_OF_ORIGIN_FOR_PAYMENT.MR_W8_W9_PAYMENT,
                                PayerId: payerId,
                                payerId: payerId,
                                FormType: selectedW8W9Form.value,
                                isW8orW9Payment: "W8"
                            }

                            dispatch(requestBulkW8(data))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select form to proceed." }))
                        }
                    },
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => dispatch(setW8W9FormsModal(false)),
                    cancelButtonText: "Cancel",
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                value={selectedW8W9Form}
                name="prepayRequests"
                placeHolder="Select a form"
                onSelectCb={(name, selectedOption) => dispatch(setSelectedW8W9Form(selectedOption))}
                options={w8Forms}
            />

            {w8W9PaymentDrawerModal &&
                <PaymentDrawer
                    isOpen={w8W9PaymentDrawerModal}
                    onCloseCb={() => {
                        dispatch(setW8W9PaymentDrawerModal(false))
                    }}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: W8W9Fees,
                        FilingFee: W8W9Fees,
                        USPSFee: "0",
                        TINMatchFee: "0",
                        StateFee: "0",
                        TINCount: "0",
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: "0"
                    }}
                    filingFeeLabel={`${requestType === REQUEST_TYPE_STATUS.W8REQUEST ? "W8" : "W9"} Fee`}
                    calculatePrepaySalesTax={true}
                    paymentServiceFunctionCb={requestType === REQUEST_TYPE_STATUS.W8REQUEST ? RecipientDataService.requestBulkW8 : RecipientDataService.requestBulkW9}
                    onPaymentSuccessCb={() => {
                        navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}`);
                        dispatch(addNotifications({ heading: "Success", message: `${requestType === REQUEST_TYPE_STATUS.W8REQUEST ? "W8" : "W9"} request successful`, variant: TOASTER_VARIANT.SUCCESS }))
                    }}
                    placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.MR_W8_W9_PAYMENT}
                    paymentServiceFunctionExtraParams={{
                        RecipientIds: Array.isArray(recipientIds) ? recipientIds : [recipientIds],
                        adminuserPayment: true,
                        AllSelected: false,
                        CheckPrepay: "No",
                        FormType: requestType == REQUEST_TYPE_STATUS.W8REQUEST ? "W8" : "W9",
                        HiddenTotalFee: "",
                        isAccountant: "true",
                        IsautorenewChecked: false,
                        IsBulkTin: "No",
                        IsNoticeChecked: true,
                        isW8orW9Payment: requestType == REQUEST_TYPE_STATUS.W8REQUEST ? "W8" : "W9",
                        payerId: payerId,
                        payername: "",
                        PaymentEmail: submittedRecipient.emailid || "",
                        planPlanType: selectedW8W9Plan.value,
                        selectAll: false,
                        w8W9PlanType: selectedW8W9Plan.value,
                        w9PdfImportPrepayLbl: ""
                    }}
                />
            }

            {/* W9 request modal */}

            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Click on proceed to continue sending bulk W9 requests'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={w9RequestModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        const data = {
                            RecipientIds: Array.isArray(recipientIds) ? recipientIds : [recipientIds],
                            totalAmount: W8W9Fees,
                            prepay: "Yes",
                            isPrepaid: "true",
                            selectAll: "false",
                            isAccountant: "true",
                            placeOfOriginforpayment: PLACE_OF_ORIGIN_FOR_PAYMENT.MR_W8_W9_PAYMENT,
                            PayerId: payerId,
                            payerId: payerId,
                            FormType: "W9",
                            isW8orW9Payment: "W9"
                        }

                        dispatch(requestBulkW9(data))
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setW9RequestModal(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />

        </>
    )
}

export default W8W9PaymentModals
